import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toastr } from "react-redux-toastr";
import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
import { onHeaderCheckboxClickHandler } from "../redux/actions/selectAction";
import { FreezeAllModal } from "./freezeModal";
import {
  setFreezeAllModalOpen,
  setPushNotificationModal,
} from "../redux/actions/member/memberAction";
import { setCheckPasswordModalOpen } from "../redux/actions/staff/staffAction";
import { CheckPassword } from "./modals/checkPassword";
import { checkPassword } from "../redux/actions/api/apiAction";
import { PushNotification } from "./pushNotification";

const QuickActions = (props) => {
  const dispatch = useDispatch();
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [modal, setModal] = useState(false);
  const [selectedMember, setSelectedMember] = useState(null);
  const { members } = useSelector((state) => state.member);
  const { loginUser } = useSelector((state) => state.login);
  const { gymConfig } = useSelector((state) => state.gym);

  const { permissions, subAdminType, subAdminPermissions } = useSelector(
    (state) => state.permissions
  );
  const toggleModal = () => {
    dispatch(setCheckPasswordModalOpen(true));
  };
  const toggleFreezeAllModal = () => dispatch(setFreezeAllModalOpen(true));
  const toggle = () => setDropdownOpen((prevState) => !prevState);

  const handleCheckPassword = async (password) => {
    let flag = await dispatch(checkPassword(password));
    if (flag) {
      toggleFreezeAllModal();
    }
    dispatch(setCheckPasswordModalOpen(false));
  };

  const handleClickItem = (title) => {
    switch (title) {
      case "Freeze All":
        toggleModal();
        break;
      case "Unfreeze All":
        dispatch(onHeaderCheckboxClickHandler(members, "members"));
        break;
      case "Freeze Subscription":
        toggleModal();
        break;
      case "Push Notification":
        dispatch(setPushNotificationModal(true));
        break;
      default:
        break;
    }
  };
  const dropdownitems = props.dropdownitems;
  const listItems = dropdownitems
    .filter((el) => {
      if (el.innertitle == "Push Notification") {

        if (!gymConfig?.sendCustomPushNotifications?.enabled) {
          return false;
        }

        if (
          (loginUser.role == "STAFF" && !permissions["S-PU-NOT"]) ||
          (subAdminType === "SUB_ADMIN" && !subAdminPermissions["S-PU-NOT"])
        ) {
          return false;
        } else return true;
      } else if (el.innertitle == "Freeze All") {

        if (!gymConfig?.manageMemberships?.enabled || !gymConfig?.manageMemberships?.freezeAllOrSelection) {
          return false;
        }
        return true;
        
      } else return true;
    })
    .map((items) => (
      <DropdownItem onClick={() => handleClickItem(items.innertitle)}>
        {props.selection.length && items.innertitle == "Freeze All"
          ? (items.innertitle = "Freeze Subscription")
          : items.innertitle}
      </DropdownItem>
    ));

  return (
    <>
      <Dropdown
        isOpen={dropdownOpen}
        toggle={toggle}
        className="custom-dropdown-qa"
      >
        <DropdownToggle caret color="transparent">
          {props.maintitle}
        </DropdownToggle>
        <DropdownMenu className="custom-dropdown-block">
          <div className="sub-title">{props.subTitle}</div>
          {listItems}
        </DropdownMenu>
      </Dropdown>
      <FreezeAllModal selectedMember={props.selection} />
      <CheckPassword handleSubmit={handleCheckPassword} />
      <PushNotification selectedMember={props.selection} />
    </>
  );
};

export default QuickActions;
